<template>
  <section>
    <form class="topup-form" @submit.prevent="submit">
      <div class="topup-form-frame">
        <div class="topup-loading" v-if="isLoading">{{ $t('component.blik.loadingText') }}</div>
        <h1>{{ $t('component.blik.header') }}</h1>
        <div class="blik-summary">
          <div>
            <p>{{ $t('component.blik.verifyText1') }}</p>
            <p>{{ $t('component.blik.verifyText2') }}</p>
            <div class="topup-form-fields" style="margin-top: 30px">
              <section class="topup-form-field-zone">
                <div class="topup-form-field">
                  <div class="topup-form-field-container" :class="{error: isBlikCodeError()}">
                    <label for="blikCode">{{ $t('component.blik.labelBlik') }}</label>
                    <input type="text"
                           autocomplete="off"
                           id="blikCode"
                           ref="blikCode"
                           v-model="form.token"
                           v-mask="'### ###'"
                           @blur="checkBlikCode">
                  </div>
                  <div class="topup-form-error-container email-error" v-if="isBlikCodeError()">
                    <ul>
                      <li v-if="isBlikCodeEmpty()">{{ $t('component.blik.errorFieldRequired') }}</li>
                      <li v-if="!isBlikCodeEmpty() && !isBlikCodeValid()">{{ $t('component.blik.errorFieldPattern') }}</li>
                      <li v-if="showBlikBankNotSupported">{{ $t('component.blik.errorBankNotSupported') }}</li>
                    </ul>
                  </div>
                </div>
              </section>
            </div>
            <div class="topup-description">
              <p v-html="$t('component.blik.descriptionText')"></p>
            </div>
          </div>
          <div class="blik-description">
            <div v-html="$t('component.blik.blikDescription')"></div>
            <div class="blik-supported-banks">
              <ul>
                <li v-for="(bank, index) in bankList" :key="index">
                  <span class="bank-icon" :style="getBankIconUrl(bank.iconUrl)"></span>
                  <span class="bank-name">{{ bank.name }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="topup-form-buttons">
        <span></span>
        <button id="submit-blik" type="submit" :disabled="isLoading">{{ $t('component.blik.buttonNext') }} ›</button>
      </div>
    </form>
  </section>
</template>
<script>
import BlikFormMixin from '@/common/mixins/Blik/Form.mixin'
export default {
  name: 'BlikForm',
  mixins: [BlikFormMixin]
}
</script>

<style src="../../assets/scss/topup-form.scss" lang="scss"></style>
<style lang="scss">
@import '../../assets/scss/variables';
#blikCode {
  width: 150px;
}
.blik-summary {
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-start;
  gap: 10px;

  @media (min-width: $res-m) {
    flex-direction: row;
    gap: 50px;

    & > div {
      width: 50%;
    }
  }
  .blik-supported-banks {
    ul {
      list-style: none none;
      margin: 0;
      padding: 0;
    }

    li {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      padding: 5px 0;

      .bank-icon {
        display: block;
        width: 80px;
        height: 50px;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center center;
      }
      .bank-name {
        font-size: 14px;
        margin: 10px;
      }
    }
  }

  .blik-description {
    font-size: 12px;
    line-height: 18px;
    font-weight: 400;
    border: 1px solid #2cb43a;
    background-color: #f4f4f4;
    padding: 20px;

    @media (min-width: $res-l) {
      font-size: 14px;
      line-height: 20px;
    }
  }
}
</style>
